export class Controller {

    /** @ngInject */
    constructor(Alert, DestructiveOperationModal) {
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    $onInit() {
        this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
        this.isHardTokenUser = this.account.roles.includes('ROLE_HARD_TOKEN_USER') || this.account.isSecondaryDeviceSession;
    }

    showDeleteConnectorDP(id) {
        this.DestructiveOperationModal({
            titleKey: 'connectors.messages.delete_connector',
            textKey: 'connectors.messages.warning',
            http: {method: 'DELETE', url: `app/rest/connectors/${id}`},
        }).then(() => {
            const index = this.connectors.findIndex(c => c.id === id);
            this.connectors.splice(index, 1);
            this.Alert('success', 'connectors.messages.delete');
        });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/connectors/connectors.controller.js